import {BACKEND_BASE_URL} from '@/config';
const DEVELOPER_TOKEN_ENDPOINT = `${BACKEND_BASE_URL}/xsm-api/v1/proxy/oauth2/token`;
const DEVELOPER_REVOKE_ENDPOINT = `${BACKEND_BASE_URL}/xsm-api/v1/proxy/revoke/`;

//endpoints
const DOMAIN_API_URL = '/xsm-api/v1/domain';
const GROUP_API_URL = '/xsm-api/v1/group';
const MAPPING_API_URL = '/xsm-api/v1/mapping';
const ORGANIZATION_API_URL = '/xsm-api/v1/organization';
const ROLE_API_URL = '/xsm-api/v1/role';
const USER_API_URL = '/xsm-api/v1/user';
const APP_API_URL = '/xsm-api/v1/application';
const ADMIN_USER_API_URL = '/xsm-api/v1/admin/user';
const PUBLISHER_API_URL = '/xsm-api/v1/publisher/apis';
const DEVELOPER_API_URL = '/xsm-api/v1/devportal/apis';
const DEVELOPERAPP_API_URL = '/xsm-api/v1/devportal';
const DEV_SUB = '/xsm-api/v1/devportal/subscription';
const DEVELOPERAPP_API_URL_SUB_ADD = '/xsm-api/v1/devportal/subscription/add';
const DEVELOPERAPP_API_URL_SUB_REMOVE = '/xsm-api/v1/devportal/subscription/remove';
const AUTHENTICATION_SETTING_API = '/xsm-api/v1/mfaauthpolicy';
const ANALYTICS_API = '/xsm-api/v1/stats';
const APP_TOKEN = '/xsm-api/v1/token';
const PERMISSION_API_URL = '/xsm-api/v1/permission';
const SUBSCRIPTION_API_URL = '/xsm-api/v1/devportal/subscription';
const PASSWORD_POLICY_URL = '/xsm-api/v1/passwordpolicy';
const APPLICATION_CREATION_API_URL = '/xsm-api/v1/admin/application';
const ENTITY_ROLE_API_URL = '/xsm-api/v1/admin/roles';
const ENTITY_RESOURCES_API_URL = '/xsm-api/v1/admin/resources';
const ENTITY_COMPONENTS_API_URL = '/xsm-api/v1/admin/components';
const RESOURCE_COMPONENT_MAPPING_API_URL = '/xsm-api/v1/admin/resource-component-mappings';
const FETCH_RESOURCE_COMPONENT_API_URL = '/xsm-api/v1/admin/resources/components';
const ROLE_RESOURCE_MAPPING_API_URL = '/xsm-api/v1/admin/resource-component-mappings';

//Sample application repositories
const XSM_SAMPLE_REACT_APP = 'https://github.com/vamshi859/xsm-sample-react-app/archive/refs/heads/master.zip';
const XSM_SAMPLE_JS_APP = 'https://github.com/vamshi859/xsm-sample-js-app/archive/refs/heads/master.zip';

export {
  DOMAIN_API_URL,
  GROUP_API_URL,
  MAPPING_API_URL,
  ORGANIZATION_API_URL,
  ROLE_API_URL,
  USER_API_URL,
  ADMIN_USER_API_URL,
  PUBLISHER_API_URL,
  DEVELOPER_API_URL,
  DEVELOPERAPP_API_URL,
  DEVELOPERAPP_API_URL_SUB_ADD,
  DEVELOPERAPP_API_URL_SUB_REMOVE,
  DEVELOPER_TOKEN_ENDPOINT,
  DEVELOPER_REVOKE_ENDPOINT,
  AUTHENTICATION_SETTING_API,
  ANALYTICS_API,
  APP_API_URL,
  APP_TOKEN,
  DEV_SUB,
  PERMISSION_API_URL,
  SUBSCRIPTION_API_URL,
  PASSWORD_POLICY_URL,
  XSM_SAMPLE_REACT_APP,
  XSM_SAMPLE_JS_APP,
  APPLICATION_CREATION_API_URL,
  ENTITY_ROLE_API_URL,
  ENTITY_COMPONENTS_API_URL,
  ENTITY_RESOURCES_API_URL,
  RESOURCE_COMPONENT_MAPPING_API_URL,
  ROLE_RESOURCE_MAPPING_API_URL,
  FETCH_RESOURCE_COMPONENT_API_URL,
};
